export enum OnboardingLoginType {
    LOGIN = 'LOGIN',
    REGISTER = 'REGISTER',
    ACCESSIBILITY = 'ACCESSIBILITY',
    HELP = 'HELP',
    SKIP = 'SKIP'
}
